import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersExcelParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersExcel = createAsyncThunk<
  void,
  GetVouchersExcelParams
>(
  `vouchers/getVouchersExcel`,
  async ({ voucherId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersExcel({ voucherId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers excel",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers excel", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
